import React from 'react';
import { connect } from 'react-redux';

const NextCatchup = (props) => {
  if (!props.progress.catchup) return null;

  return (
    <div className="catchup">
      <div className="header">Your next catchup is due on {props.progress.catchup} <span>({props.progress.catchupType.replace('follow-up', '')} review)</span></div>
    </div>
  );
}

export default connect(state => ({
  progress: state.progress
}))(NextCatchup);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/NextCatchup.jsx